"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var Trace = require('./FDS-Trace');

class FDSContract {
  // later we dynamically create methods
  constructor(config) {
    var account = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var abi = arguments.length > 2 ? arguments[2] : undefined;
    var bytecode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '0x';
    this.account = account;
    this.config = config;
    this.abi = abi;
    this.bytecode = bytecode;
    this.web3 = this.config.web3;
    this.contractAddress = null;
  }

  at(contractAddress) {
    var _this = this;

    this.contractAddress = contractAddress;
    this.web3Instance = new this.web3.eth.Contract(this.abi, this.contractAddress);

    var _loop = function _loop() {
      var {
        type,
        stateMutability,
        name
      } = _this.abi[i];

      if (type === 'function' && stateMutability === 'view') {
        _this[name] = function () {
          return this.call(name, [...arguments]);
        };
      } else if (type === 'function' && (stateMutability === 'payable' || stateMutability === 'nonpayable')) {
        _this[name] = function () {
          return this.send(name, [...arguments], true);
        };
      }
    };

    for (var i = 0; i < this.abi.length; i++) {
      _loop();
    }

    return this;
  }

  deploy() {
    var _this2 = this;

    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    Trace.time('deployTransaction//Contract');
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (resolve, reject) {
        var contract = new _this2.web3.eth.Contract(_this2.abi);
        var deployData = {
          data: _this2.bytecode
        };

        if (args !== []) {
          deployData.arguments = args;
        }

        var dataTx = contract.deploy(deployData).encodeABI();
        var privateKey = _this2.account.privateKey;
        var tx = {
          from: _this2.account.address,
          data: dataTx
        };
        var currentGas = yield _this2.web3.eth.getGasPrice();
        var requiredGasPrice = yield _this2.web3.eth.estimateGas(tx);
        tx.nonce = _this2.account.nonce;
        tx.gas = requiredGasPrice;
        tx.gasPrice = currentGas;
        _this2.account.nonce += 1;
        return _this2.web3.eth.accounts.signTransaction(tx, privateKey).then(signed => {
          return _this2.web3.eth.sendSignedTransaction(signed.rawTransaction).once('confirmation', (i, receipt) => {
            Trace.timeEnd('deployTransaction//Contract');
            _this2.transactionReceipt = receipt;
            resolve(_this2.at(receipt.contractAddress));
          });
        });
      });

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  send(method) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var confirm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var gas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6000000;
    var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    Trace.time('sendTransaction//Contract');
    return new Promise((resolve, reject) => {
      if (this.contractAddress === null || this.contractAddress === '0x0') {
        throw new Error('you must use ".at" or ".deploy" first');
      }

      var web3Instance = new this.web3.eth.Contract(this.abi, this.contractAddress);
      var dataTx = web3Instance.methods[method](...args).encodeABI();
      var privateKey = this.account.privateKey;
      var tx = {
        from: this.account.address,
        to: this.contractAddress,
        data: dataTx,
        gas: gas,
        nonce: this.account.nonce,
        value: value
      };
      this.account.nonce += 1;
      return this.web3.eth.accounts.signTransaction(tx, privateKey).then(signed => {
        return this.web3.eth.sendSignedTransaction(signed.rawTransaction).once('transactionHash', function (hash) {
          if (confirm === false) {
            Trace.log('sendTransaction//Contract', method, confirm);
            Trace.timeEnd('sendTransaction//Contract');
            resolve(hash);
          }
        }).once('confirmation', function (i, hash) {
          if (confirm === true) {
            Trace.log('sendTransaction//Contract', method, confirm);
            Trace.timeEnd('sendTransaction//Contract');
            resolve(hash);
          }
        });
      });
    });
  }

  call(method) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    Trace.time('call//Contract');

    if (this.contractAddress === null || this.contractAddress === '0x0') {
      throw new Error('you must use ".at" or ".deploy" first');
    }

    var web3Instance = new this.web3.eth.Contract(this.abi, this.contractAddress);
    var address = this.account === undefined ? '0x' : this.account.address;
    var response = web3Instance.methods[method](...args).call({
      from: address
    });
    Trace.log('call//Contract', method);
    Trace.timeEnd('call//Contract');
    return response;
  }

  getPastEvents() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'allEvents';
    var options = arguments.length > 1 ? arguments[1] : undefined;
    return new this.web3.eth.Contract(this.abi, this.contractAddress).getPastEvents(event, options);
  }

}

var _default = FDSContract;
exports.default = _default;
module.exports = exports.default;